import React from 'react';

import { HashRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Header from 'components/Header';
import Loading from 'components/Loading';
import Modal from 'components/Modal';
import ScrollToTop from 'components/ScrollToTop';
import CancelSchedule from 'pages/Survey/_components/CancelSchedule';
import Schedule from 'pages/Survey/_components/SettingSchedule';
import AppRoutes from 'routes/AppRoutes';

import 'react-toastify/dist/ReactToastify.css';

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <div data-testid="app">
        <AppRoutes />
      </div>
      <Modal />
      <Schedule />
      <CancelSchedule />
      <Loading />
      <ToastContainer pauseOnFocusLoss={false} pauseOnHover={false} autoClose={3000} className="z-max" />
    </Router>
  );
};

export default React.memo(App);
